import { STORE_NAME } from './reducer';
import { UPDATE_CAMERA_ACTIVE_PARTICIPANTS, UPDATE_CAMERA_INACTIVE_PARTICIPANTS, UPDATE_PARTICIPANTS_BY_CAMERA_STATE } from './actions';
const getParticipantsState = (state) => {
    return state[STORE_NAME];
};
export const getParticipantsByCameraState = (state) => {
    return getParticipantsState(state).participantsByCameraState;
};
export const getCameraInactiveParticipants = (state) => {
    return getParticipantsState(state).participantsByCameraState.inactive;
};
export const getCameraActiveParticipants = (state) => {
    return getParticipantsState(state).participantsByCameraState.active;
};
export const setParticipantsByCameraState = (participants) => {
    return {
        type: UPDATE_PARTICIPANTS_BY_CAMERA_STATE,
        participants,
    };
};
export const setCameraInactiveParticipants = (participants) => {
    return {
        type: UPDATE_CAMERA_INACTIVE_PARTICIPANTS,
        participants,
    };
};
export const setCameraActiveParticipants = (participants) => {
    return {
        type: UPDATE_CAMERA_ACTIVE_PARTICIPANTS,
        participants,
    };
};
